import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const OfficeBagIcon = forwardRef<SVGSVGElement, IconProps>(function BagIcon(
  { color = '', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.18922 4.69969C5.60208 4.72896 5.96397 4.46083 5.99753 4.10081C6.08146 3.20062 6.41142 2.50385 6.90234 2.04068C7.38091 1.58915 8.06536 1.30807 9 1.30807C9.93464 1.30807 10.6191 1.58915 11.0977 2.04068C11.5886 2.50385 11.9185 3.20062 12.0025 4.10081C12.036 4.46083 12.3979 4.72896 12.8108 4.69969C13.2236 4.67042 13.5311 4.35484 13.4975 3.99481C13.394 2.88388 12.9739 1.88376 12.1992 1.15282C11.4122 0.410244 10.3154 0 9 0C7.68464 0 6.58784 0.410246 5.80079 1.15282C5.02608 1.88376 4.60604 2.88388 4.50247 3.99481C4.4689 4.35484 4.77637 4.67042 5.18922 4.69969Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.041 7.11825C16.0397 7.11486 16.0384 7.11148 16.0371 7.1081C15.7103 6.26913 15.2099 5.81245 14.2839 5.50041C13.2164 5.14071 11.5817 4.97879 9 4.97879C6.41827 4.97879 4.78357 5.14071 3.71611 5.50041C2.79009 5.81245 2.28971 6.26913 1.96293 7.1081C1.96162 7.11148 1.9603 7.11486 1.959 7.11825C2.36995 7.50235 2.91699 7.97587 3.56483 8.44813C5.07774 9.551 7.01979 10.5584 9 10.5584C10.9802 10.5584 12.9223 9.551 14.4352 8.44813C15.083 7.97587 15.63 7.50235 16.041 7.11825ZM17.6976 7.4639C17.6306 7.18639 17.5511 6.92795 17.4574 6.68741C17.3734 6.47186 17.2781 6.27067 17.1704 6.08302C16.0808 4.18413 13.7225 3.67072 9 3.67072C4.27752 3.67072 1.91919 4.18413 0.829554 6.08302C0.721873 6.27067 0.626581 6.47186 0.542623 6.68741C0.448933 6.92795 0.369355 7.18639 0.302421 7.4639C0.0837265 8.37058 0 9.48081 0 10.8354C0 16.7354 1.5885 18 9 18C16.4115 18 18 16.7354 18 10.8354C18 9.48081 17.9163 8.37058 17.6976 7.4639ZM1.60692 8.67079C1.53468 9.27358 1.5 9.98707 1.5 10.8354C1.5 13.82 1.94651 15.0388 2.73199 15.6641C3.12521 15.9772 3.73247 16.2456 4.76527 16.4283C5.80805 16.6128 7.17808 16.6919 9 16.6919C10.8219 16.6919 12.1919 16.6128 13.2347 16.4283C14.2675 16.2456 14.8748 15.9772 15.268 15.6641C16.0535 15.0388 16.5 13.82 16.5 10.8354C16.5 9.98707 16.4653 9.27358 16.3931 8.67079C16.0944 8.92192 15.7608 9.18666 15.3972 9.45173C13.8064 10.6114 11.5198 11.8665 9 11.8665C6.48021 11.8665 4.19358 10.6114 2.60279 9.45173C2.23917 9.18666 1.90559 8.92192 1.60692 8.67079Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
